import {
  FETCH_BOOKED_SEATS_REQUEST,
  FETCH_BOOKED_SEATS_SUCCESS,
  FETCH_BOOKED_SEATS_FAILURE,
  RESET_SEATS_REQUEST,
  RESET_SEATS_SUCCESS,
  RESET_SEATS_FAILURE,
} from '../actions/constants';

const initialState = {
  bookedSeats: [],
  loading: false,
  error: null,
};

export default function seatReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_BOOKED_SEATS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BOOKED_SEATS_SUCCESS:
      return { ...state, loading: false, bookedSeats: action.payload };
    case FETCH_BOOKED_SEATS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case RESET_SEATS_REQUEST:
      return { ...state, loading: true };
    case RESET_SEATS_SUCCESS:
      return { ...state, loading: false, bookedSeats: [] };
    case RESET_SEATS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
} 